export default __webpack_public_path__ + "static/media/i-interior-sura.a9a26ec6.svg";